/**
 * Locale (en-US) — Document Manager (AUTOMY's "Google Drive").
 */
export default {
  'documents.title': 'Documents',
  'documents.summary': 'Organize, upload and browse every document in the system inside folders.',
  'documents.refresh': 'Refresh',

  'documents.action.upload': 'Upload',
  'documents.action.newFolder': 'New folder',
  'documents.action.exports': 'My exports',

  'documents.breadcrumb.root': 'My drive',
  'documents.breadcrumb.byProcess': 'By process',
  'documents.breadcrumb.byProcessInstance': 'By request',
  'documents.breadcrumb.byForm': 'By form',
  'documents.breadcrumb.byEntity': 'By entity',
  'documents.breadcrumb.byList': 'By list',
  'documents.breadcrumb.byChatThread': 'By chat',

  'documents.groupBy.label': 'View by',
  'documents.groupBy.folder': 'Folders',
  'documents.groupBy.process': 'Process',
  'documents.groupBy.processInstance': 'Request',
  'documents.groupBy.form': 'Form',
  'documents.groupBy.entity': 'Entity',
  'documents.groupBy.list': 'List',
  'documents.groupBy.chatThread': 'Chat',
  'documents.group.none': 'Unassigned',

  'documents.view.list': 'List view',
  'documents.view.grid': 'Grid view',

  'documents.section.folders': 'Folders',
  'documents.section.files': 'Files',

  'documents.order.nameAsc': 'Name (A-Z)',
  'documents.order.nameDesc': 'Name (Z-A)',
  'documents.order.recent': 'Newest',
  'documents.order.oldest': 'Oldest',
  'documents.order.sizeDesc': 'Largest',
  'documents.order.sizeAsc': 'Smallest',

  'documents.filters.toggle': 'Filters',
  'documents.filters.clearAll': 'Clear filters',
  'documents.filters.type': 'File type',
  'documents.filters.source': 'Source',
  'documents.filters.process': 'Process',
  'documents.filters.owner': 'Owner',
  'documents.filters.date': 'Created date',

  'documents.columns.name': 'Name',
  'documents.columns.owner': 'Owner',
  'documents.columns.source': 'Source',
  'documents.columns.size': 'Size',
  'documents.columns.modified': 'Modified',

  'documents.item.open': 'Open',
  'documents.item.preview': 'Preview',
  'documents.item.details': 'View details',
  'documents.item.download': 'Download',
  'documents.item.rename': 'Rename',
  'documents.item.move': 'Move',
  'documents.dnd.dropToMove': 'Drop to move here',
  'documents.item.delete': 'Delete',
  'documents.item.openRequest': 'Go to request',

  'documents.details.title': 'Details',
  'documents.details.collapse': 'Hide details',
  'documents.details.expand': 'Show details',
  'documents.details.close': 'Close',
  'documents.details.general': 'General information',
  'documents.details.context': 'AUTOMY context',
  'documents.details.type': 'Type',
  'documents.details.contentType': 'Content type',
  'documents.details.size': 'Size',
  'documents.details.owner': 'Owner',
  'documents.details.created': 'Created',
  'documents.details.updated': 'Last modified',
  'documents.details.source': 'Source',
  'documents.details.process': 'Process',
  'documents.details.request': 'Request',
  'documents.details.form': 'Form',
  'documents.details.field': 'Field',
  'documents.details.action': 'Action',
  'documents.details.folder': 'Folder',
  'documents.zoom.in': 'Zoom in',
  'documents.zoom.out': 'Zoom out',
  'documents.zoom.reset': 'Reset zoom',
  'documents.zoom.loadError': 'Could not load the image.',

  'documents.type.unknown': 'File',
  'documents.type.image': 'Image',
  'documents.type.video': 'Video',
  'documents.type.pdf': 'PDF',
  'documents.type.word': 'Word',
  'documents.type.excel': 'Excel',
  'documents.type.powerPoint': 'PowerPoint',
  'documents.type.microsoftProject': 'Microsoft Project',
  'documents.type.text': 'Text',
  'documents.type.xml': 'XML',
  'documents.type.html': 'HTML',
  'documents.type.json': 'JSON',
  'documents.type.zip': 'ZIP',
  'documents.type.audio': 'Audio',
  'documents.type.rar': 'RAR',
  'documents.type.font': 'Font',
  'documents.type.textCsv': 'CSV',
  'documents.type.androidApk': 'Android APK',
  'documents.type.exeFile': 'Executable',
  'documents.type.parquetFile': 'Parquet',
  'documents.type.outlookMessage': 'Outlook Message',
  'documents.type.markdown': 'Markdown',

  'documents.source.processInstanceFormFieldAttachment': 'Form attachment',
  'documents.source.processInstanceGeneratedDocument': 'Generated document',
  'documents.source.processInstanceVariableAttachment': 'Variable attachment',
  'documents.source.processInstanceCommentAttachment': 'Comment attachment',
  'documents.source.entityAttachment': 'Entity attachment',
  'documents.source.processInstanceApiCallAttachment': 'API attachment',
  'documents.source.listExportGeneratedFile': 'List export',
  'documents.source.dynamicEntityExportGeneratedFile': 'Entity export',
  'documents.source.dynamicEntityImportGeneratedErrorFile': 'Import errors',
  'documents.source.processInstanceOpenAICallAttachment': 'AI attachment',
  'documents.source.processInstanceAutomyAIAttachment': 'Automy AI attachment',
  'documents.source.processInstanceRunCodeAttachment': 'Code attachment',
  'documents.source.chatThreadAttachment': 'Chat attachment',
  'documents.source.configurationEntityExportGeneratedFile': 'Configuration export',
  'documents.source.configurationEntityImportGeneratedErrorFile': 'Configuration import errors',
  'documents.source.manualUpload': 'Manual upload',
  'documents.source.documentManagerBulkExportGeneratedFile': 'Bulk export',

  'documents.selection.select': 'Select',
  'documents.selection.deselect': 'Deselect',
  'documents.selection.count': '{count, plural, one {# document} other {# documents}} · {size}',
  'documents.selection.countFolders':
    '{count, plural, one {# folder} other {# folders}} (includes nested files)',
  'documents.selection.countMixed':
    '{documents, plural, one {# document} other {# documents}}, {folders, plural, one {# folder} other {# folders}} · {size}',
  'documents.selection.limitsHint': 'You can export up to {max} items or 5 GB',
  'documents.selection.limitReachedCount': 'You’ve reached the {max}-item limit',
  'documents.selection.limitReachedSize': 'Selection exceeds the 5 GB limit',
  'documents.selection.bulkLimitHint': 'To move or delete, select at most {max} items',
  'documents.selection.selectVisible': 'Select visible',
  'documents.selection.clear': 'Clear selection',
  'documents.export.action': 'Export selection',
  'documents.export.exporting': 'Exporting...',
  'documents.export.emptySelection': 'Select at least one document or folder.',
  'documents.export.maxCount': 'You can export at most {max} items at a time.',
  'documents.export.maxSize': 'The selection exceeds the 5 GB size limit.',
  'documents.export.started':
    'Export {taskNumber} started ({count} item(s)). We will notify you when it is ready.',
  'documents.export.pending': 'Export queued',
  'documents.export.processing': 'Generating ZIP...',
  'documents.export.ready': 'Export ready to download',
  'documents.export.failed': 'Export failed',
  'documents.export.summary': '{exported} exported · {skipped} skipped',
  'documents.export.download': 'Download ZIP',
  'documents.export.dismiss': 'Dismiss',

  'documents.bulk.move': 'Move',
  'documents.bulk.delete': 'Delete',
  'documents.bulk.moveTitle': 'Move selection',
  'documents.bulk.deleteTitle': 'Delete selection',
  'documents.bulk.moveConfirm':
    'You are about to move {count} item(s) ({documents} document(s), {folders} folder(s)).',
  'documents.bulk.deleteConfirm':
    'Are you sure you want to delete {count} item(s)? This cannot be undone.',
  'documents.bulk.deleteConfirmCascade':
    'Are you sure you want to delete {count} item(s) ({documents} document(s), {folders} folder(s))? Folders are deleted recursively with all their contents.',
  'documents.bulk.maxItems': 'You can move or delete at most {max} items at a time.',
  'documents.msg.bulkMoved': 'Items moved.',
  'documents.msg.bulkDeleted': 'Items deleted.',

  'documents.exportTasks.title': 'My exports',
  'documents.exportTasks.subtitle': 'ZIPs generated from Documents. Available for 7 days.',
  'documents.exportTasks.empty': 'No exports yet',
  'documents.exportTasks.emptyHint':
    'Select documents or folders and use “Export selection” to generate a ZIP.',
  'documents.exportTasks.generating': 'Generating file…',
  'documents.exportTasks.expires': 'Available until {date}',
  'documents.exportTasks.loadMore': 'Load more',
  'documents.exportTasks.loadingMore': 'Loading…',
  'documents.exportTasks.status.pending': 'Queued',
  'documents.exportTasks.status.processing': 'Processing',
  'documents.exportTasks.status.processed': 'Ready',
  'documents.exportTasks.status.error': 'Error',
  'documents.exportTasks.status.cancelled': 'Cancelled',

  'documents.empty.title': 'This folder is empty',
  'documents.empty.description': 'Upload documents or create a folder to start organizing.',
  'documents.empty.search': 'No results matched your search or filters.',

  'documents.folder.newTitle': 'New folder',
  'documents.folder.renameTitle': 'Rename folder',
  'documents.folder.nameLabel': 'Folder name',
  'documents.folder.namePlaceholder': 'Untitled',
  'documents.folder.colorLabel': 'Color',

  'documents.document.renameTitle': 'Rename document',
  'documents.document.nameLabel': 'File name',

  'documents.upload.title': 'Upload documents',
  'documents.upload.dragText': 'Drag files or folders here',
  'documents.upload.hint':
    'Or pick them below. Dropping a folder creates it with all its contents.',
  'documents.upload.browse': 'Choose files',
  'documents.upload.browseFolder': 'Choose folder',
  'documents.upload.addMore': 'Add files',
  'documents.upload.addMoreFolder': 'Add folder',
  'documents.upload.selected': '{count} file(s) · {size}',
  'documents.upload.selectedWithFolders': '{files} file(s) · {folders} folder(s) · {size}',
  'documents.upload.clearAll': 'Clear all',
  'documents.upload.removeFile': 'Remove file',
  'documents.upload.submit': 'Upload',
  'documents.upload.submitCount': 'Upload {count}',
  'documents.upload.uploading': 'Uploading...',
  'documents.upload.progressFolders': 'Creating folders ({current}/{total})',
  'documents.upload.progressFiles': 'Uploading files ({current}/{total})',
  'documents.upload.dropHere': 'Drop to upload here',
  'documents.upload.dropHereHint': 'Files and folders go into the current folder',

  'documents.move.title': 'Move to',
  'documents.move.destinationLabel': 'Destination folder',
  'documents.move.root': 'My drive (root)',
  'documents.move.submit': 'Move here',

  'documents.delete.folderTitle': 'Delete folder',
  'documents.delete.documentTitle': 'Delete document',
  'documents.delete.folderConfirm':
    'Are you sure you want to delete the folder "{name}"? This action cannot be undone.',
  'documents.delete.documentConfirm': 'Are you sure you want to delete the document "{name}"?',

  'documents.msg.folderCreated': 'Folder created.',
  'documents.msg.folderRenamed': 'Folder renamed.',
  'documents.msg.folderMoved': 'Folder moved.',
  'documents.msg.folderDeleted': 'Folder deleted.',
  'documents.msg.documentUploaded': 'Document(s) uploaded.',
  'documents.msg.documentRenamed': 'Document renamed.',
  'documents.msg.documentMoved': 'Document moved.',
  'documents.msg.documentDeleted': 'Document deleted.',
  'documents.msg.error': 'Something went wrong. Please try again.',

  'documents.meta.items': '{count} items',
  'documents.meta.folderSuffix': 'folder',
  'documents.meta.folderSuffixPlural': 'folders',
};
